module.exports = __webpack_public_path__ + "img/PDF_THUMBNAIL.e18ea4c2.svg";